import { CSSProperties } from "react";

const ShopCart = ({ scale, color, style }: { scale?: number; color?: string; style?: CSSProperties }) => {
  let c = "#8D8E8F";
  if (color) c = color;

  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ transform: `scale(${scale || 1})` }}
    >
      <path
        d="M4.375 17.375C4.375 18.4088 5.21625 19.25 6.25 19.25C7.28375 19.25 8.125 18.4088 8.125 17.375C8.125 16.3412 7.28375 15.5 6.25 15.5C5.21625 15.5 4.375 16.3412 4.375 17.375ZM6.875 17.375C6.875 17.7194 6.59437 18 6.25 18C5.90562 18 5.625 17.7194 5.625 17.375C5.625 17.0306 5.90562 16.75 6.25 16.75C6.59437 16.75 6.875 17.0306 6.875 17.375Z"
        fill={c}
      />
      <path
        d="M15.625 17.375C15.625 16.3412 14.7838 15.5 13.75 15.5C12.7162 15.5 11.875 16.3412 11.875 17.375C11.875 18.4088 12.7162 19.25 13.75 19.25C14.7838 19.25 15.625 18.4088 15.625 17.375ZM13.125 17.375C13.125 17.0306 13.4056 16.75 13.75 16.75C14.0944 16.75 14.375 17.0306 14.375 17.375C14.375 17.7194 14.0944 18 13.75 18C13.4056 18 13.125 17.7194 13.125 17.375Z"
        fill={c}
      />
      <path
        d="M2.5625 2.375C2.64 3.11312 3.5025 11.3056 3.63562 12.5712C3.73625 13.5281 4.53812 14.25 5.50062 14.25H15.24C16.1181 14.25 16.8894 13.6263 17.0737 12.7675L18.575 5.76187C18.6544 5.39062 18.5631 5.00875 18.3244 4.71438C18.0856 4.41937 17.7313 4.25 17.3519 4.25H4.01688L3.74687 1.685C3.71312 1.36625 3.445 1.125 3.125 1.125H1.25C0.905 1.125 0.625 1.405 0.625 1.75C0.625 2.095 0.905 2.375 1.25 2.375H2.5625ZM17.3519 5.5L15.8512 12.5056C15.7894 12.7919 15.5325 13 15.2394 13H5.50062C5.17937 13 4.9125 12.7594 4.87875 12.4406L4.14813 5.5H17.3519Z"
        fill={c}
      />
    </svg>
  );
};

export default ShopCart;
